// extracted by mini-css-extract-plugin
module.exports = {"taker-assist":"taker-assist","radio-button_ta":"radio-button_ta","radio-button__label_ta":"radio-button__label_ta"};